import { connect } from "react-redux";
import FdesFormGroup from "../components/FdesFormGroup";
import {
  changeFdesParameterForm,
  clearFieldsImportErrors,
  clearUserParametersGroups,
  postFdesFile,
  saveFdesForm,
  updateFields,
  updateFormGroupState,
} from "../actions";

export default connect(
  (state) => ({
    fdesParameterGroups: state.fdes.fdesParameterGroups,
    localConfigurator: state.configurator.localConfigurator,
    fields: state.fdes.form.fields,
    calculName: state.fdes.calculName,
    importFdesFormErrors: state.fdes.importFdesFormErrors,
    hasImportedFdesForm: state.fdes.hasImportedFdesForm,
    closeImportFileModal: state.fdes.closeImportFileModal,
    userParametersGroups: state.fdes.userParametersGroups,
  }),
  (dispatch) => ({
    onChangeFdesParameterForm: (paramId, value, isAuto, fdesId) => {
      dispatch(changeFdesParameterForm(paramId, value));
      if (isAuto) {
        dispatch(saveFdesForm(fdesId));
      }
    },
    uploadFile: (paramId, file, isAuto, fdesId) => {
      dispatch(postFdesFile(paramId, file));
      if (isAuto) {
        dispatch(saveFdesForm(fdesId));
      }
    },
    updateFields: (fields, isAuto, fdesId) => {
      dispatch(updateFields(fields));
      if (isAuto === "Y") {
        dispatch(saveFdesForm(fdesId));
      }
    },
    clearFieldsImportErrors: (fields) => {
      dispatch(clearFieldsImportErrors(fields));
    },
    updateFormGroupState: (groupName, value, order) => {
      dispatch(updateFormGroupState(groupName, value, order));
    },
    clearUserParametersGroups: () => {
      dispatch(clearUserParametersGroups());
    },
  }),
)(FdesFormGroup);
